export const pasteWithoutFormatting = (
	e: ClipboardEvent,
	cb?: () => void
): void => {
	e.preventDefault();
	const text = e.clipboardData?.getData("text/plain") || "";
	const el = e.target as Element;
	el.insertAdjacentText("afterbegin", text);

	if (cb && typeof cb === "function") {
		cb();
	}
};

export function* traverseHtml(root: Element): Generator<Element> {
	for (const el of helper(root)) {
		yield el;
	}

	function* helper(el: Element): Generator<Element> {
		if (el.childNodes?.length) {
			for (const child of el.childNodes) {
				yield* helper(child as Element);
			}
		}
		yield el;
	}
}
